/**
 * Inventory Upload Domain Models
 * Defines request and response contracts for inventory upload operations
 */

/***
 *  InvUploadHeaderStatus的狀態
 *  0=待執行異動，MP=異動處理中，MF=異動完成，ME=異動異常，R=待還原，RP=還原處理中，RE=還原異常，RF=還原完成
***/
export enum InvUploadStatusEnum {
  INIT = '0',
  MANAGE_PROCESSING = 'MP',
  MANAGE_FINISHED = 'MF',
  MANAGE_ERROR = 'ME',
  WAIT_TO_RESTORE = 'R',
  RESTORATION_PROCESSING = 'RP',
  RESTORATION_ERROR = 'RE',
  RESTORATION_FINISHED = 'RF'
}

export interface DownloadInvUploadDetailRequest {
  invUploadNo: string;
}

/**
 * Request model for querying inventory uploads
 * Encapsulates date range filtering for search operations
 */
export interface GetInvUploadRequest {
  createDateStart: Date | null;
  createDateEnd: Date | null;
}

/**
 * Response model for inventory upload header information
 * Represents a single inventory upload record from the server
 */
export interface InvUploadHeaderResponse {
  invUploadNo: string;
  modifyFields: string;
  status: InvUploadStatusEnum;
  createdBy: string;
  createdAt: Date;
  updatedBy: string;
  updatedAt: Date;
}

export interface InvUploadHeaderRowData {
  seqNo: number;
  invUploadNo: string;
  modifyFields: string;
  status: InvUploadStatusEnum;
  createdBy: string;
  createdAt: Date;
  updatedBy: string;
  updatedAt: Date;
}

/**
 * Pagination metadata
 * Represents pagination information in the response
 */
export interface PageMetadata {
  number: number;
  size: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

/**
 * Paginated response wrapper
 * Contains inventory upload records and pagination metadata
 */
export interface PagedInvUploadResponse {
  content: InvUploadHeaderResponse[];
  pageable: PageMetadata;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

export enum InvUploadColumnName {
    INV_UPLOAD_NO = 'invUploadNo',
    MODIFY_FIELDS = 'modifyFields',
    STATUS = 'status',
    CREATED_BY = 'createdBy',
    CREATED_AT = 'createdAt',
    UPDATED_BY = 'updatedBy',
    UPDATED_AT = 'updatedAt',
    DOWNLOAD_DETAIL = 'downloadDetail'
}

/**
 * Table header column definition for inventory upload
 */
export interface InvUploadHeaderColumn {
  field: InvUploadColumnName;
  header: string;
  sort: string;
  type: 'text' | 'date' | 'status' | 'button';
}

/**
 * Date range event payload
 */
export interface DateRangeEvent {
  startDate: Date | null;
  endDate: Date | null;
}